import type { Page, PageableInfoNew, TvShow } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { genPagesLogicNew } from '~/shared/effector'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const resetPurchasedTvShowsRow = createEvent()
export const $purchasedTvShowsRow = createStore<Page<TvShow> | null>(null)
  .on(api.tvshows.getPurchasedTvShowsRowFx.doneData, (_, page) => page)
  .reset(resetPurchasedTvShowsRow)

export const $purchasedTvShowsRowFormatted = combine(
  $purchasedTvShowsRow,
  i18n.$t,
  (purchasedTvShowsRow) => ({
    ...purchasedTvShowsRow,
    content: purchasedTvShowsRow?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    ),
  })
)

export const resetPurchasedTvShowsGrid = createEvent()
export const $purchasedTvShowsGrid = createStore<Page<TvShow> | null>(null)
  .on(api.tvshows.getPurchasedTvShowsGridFx.doneData, (state, page) => {
    const currentTvShows = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentTvShows,
    }
  })
  .reset(resetPurchasedTvShowsGrid)

export const $purchasedTvShowsGridFormatted = combine(
  $purchasedTvShowsGrid,
  i18n.$t,
  (purchasedTvShowsGrid) => {
    const formattedPageContent = purchasedTvShowsGrid?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    )

    return {
      ...purchasedTvShowsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMorePurchasedTvShowsGrid = genPagesLogicNew(
  $purchasedTvShowsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.tvshows.getPurchasedTvShowsGridFx
)
